import { buildLinkLayer } from "./buildLayer.js";
export let EventLayerAction = /*#__PURE__*/function (EventLayerAction) {
  EventLayerAction["NavigationClick"] = "navigation_click";
  EventLayerAction["ButtonClick"] = "button_click";
  EventLayerAction["LinkClick"] = "link_click";
  EventLayerAction["IconClick"] = "icon_click";
  EventLayerAction["MainTeaserClick"] = "main_teaser_click";
  EventLayerAction["SocialMediaClick"] = "social_media_click";
  EventLayerAction["VideoClickStart"] = "video_click_start";
  EventLayerAction["VideoClickPause"] = "video_click_pause";
  EventLayerAction["VideoClickFinish"] = "video_click_finish";
  EventLayerAction["DocumentDownload"] = "document_download";
  EventLayerAction["SharePage"] = "share_page";
  EventLayerAction["ShareDocument"] = "share_document";
  EventLayerAction["InfoIconClick"] = "info_icon_click";
  EventLayerAction["DisclosureClick"] = "disclosure_click";
  EventLayerAction["TabClick"] = "tab_click";
  return EventLayerAction;
}({}); // FIXME: not documented
export let EventLayerTarget = /*#__PURE__*/function (EventLayerTarget) {
  EventLayerTarget["INTERNAL"] = "internal";
  EventLayerTarget["EXTERNAL"] = "external";
  return EventLayerTarget;
}({});
export const buildEventLayer = buildLinkLayer(({
  event_linktype = EventLayerTarget.INTERNAL,
  event_source = window.location.pathname,
  ...props
}) => ({
  event_linktype,
  event_source,
  ...props
}));